import React, { SyntheticEvent } from "react";

import { Alert as MuiAlert, Snackbar } from "@mui/material";

import { DEFAULT_SNACKBAR_DURATION } from "../../constants/index";

interface DisplayToastErrorProps {
  // The error message, pass in your desired error message directly here.
  // If using an error message from the backend, pass it in to this prop.
  errorMessage: string;

  // Boolean which controls whether snackbar alert is open or closed. Must be used
  // for when non-validation errors are being displayed.
  isOpen: boolean;

  // Handler function used to close alert and error that should be passed in from parent.
  // e.g. fn should look something like this in parent
  // (Note: logic added here to stop close on clickaway from element https://material-ui.com/components/snackbars/#customized-snackbars)
  // const handleAlertClose = (event?: Event | React.SyntheticEvent<unknown, Event>, reason?: string) => {
  //   if (reason === EventTypeReason.Clickaway) {
  //     return;
  //   }
  //   setIsAlertOpen(false);
  //   setErrorMessage("");
  // };
  handleClose: (
    event?: Event | SyntheticEvent<unknown, Event>,
    reason?: string,
  ) => void;

  // Optional string that can be used to construct more generic error messages
  // E.g. `Failed to search organisations` instead of showing backend error msg string
  genericErrorMsg?: string;
}

const DisplayToastError = ({
  errorMessage,
  isOpen,
  handleClose,
  genericErrorMsg,
}: DisplayToastErrorProps) => {
  if (errorMessage) {
    return (
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={isOpen}
        autoHideDuration={DEFAULT_SNACKBAR_DURATION}
        onClose={handleClose}
        data-testid="error-toast-alert"
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleClose}
          severity="error"
        >
          {genericErrorMsg || errorMessage}
        </MuiAlert>
      </Snackbar>
    );
  }
  return null;
};

export default DisplayToastError;
